export default __webpack_public_path__ + "static/media/menu23.226f969e.svg";